/**
 * A template literal tag function, that does nothing.
 * It returns the string as if the template literal was not tagged.
 *
 * Its purpose is, that apollo-codegen can obtain graphql
 * scripts inside typescript files, when they are tagged with 'gql'.
 * That means we are tricking apollo, by using our own 'gql' tag instead of their library.
 */
export const gql = (literals: TemplateStringsArray, ...placeholders: string[]) => {
  return literals
    .map((value, index) => `${value}${placeholders.length > index ? placeholders[index] : ''}`)
    .join('');
};

/**
 * A top-level GraphQL query.
 *
 * Consists of a query and a list of GqlQueryPartials that are *directly* used the query.
 */
export type GqlQuery = {
  gqlQuery: string;
  partials?: GqlQueryPartial[];
};

/**
 * A GraphQL partial.
 *
 * Consists of a partial definition and a list of other GqlQueryPartials used *directly* in this partial.
 */
export type GqlQueryPartial = {
  gqlPartial: string;
  partials?: GqlQueryPartial[];
};
